import { render, staticRenderFns } from "./paymentAccountsArchiveBread.vue?vue&type=template&id=4da23650"
import script from "./paymentAccountsArchiveBread.vue?vue&type=script&lang=js"
export * from "./paymentAccountsArchiveBread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports